import { BydGenericDialogDataInterface } from '../interfaces/byd-generic-dialog-data.interface';

export class BydGenericDialogData implements BydGenericDialogDataInterface {
  /**
   * title of the dialog
   */
  title: string;

  /**
   * arguments given to the translate pipe for the title
   */
  titleArgs?: string;

  /**
   * main message
   */
  message: string;

  /**
   * arguments given to the translate pipe for the message
   */
  messageArgs?: string;

  /**
   * color displayed at the top of the dialog.
   */
  state: 'warn' | 'accent' | 'primary';

  /**
   * string to display inside the accept button (has to be a translated string)
   */
  acceptButton: string;

  /**
   * string to display inside the cancel button (has to be a translated string)
   */
  cancelButton: string;

  /**
   * disable close when clicking outside the dialog
   */
  disableClose?: boolean;

  /**
   * used in some dialogs only: whether to display a retry button.
   */
  retryOption?: boolean;

  /**
   * Array of existing values (values need to be lowerCase)
   */
  existingValues?: Array<string>;

  /**
   * Value
   */
  value?: string;

  /**
   * Value show to show in a placeholder
   */
  valuePlaceholder?: string;

  /**
   * Text for disable tips
   */
  disableTips?: string;

  /**
   * Text of the delete button
   */
  deleteButton?: string;

  /**
   * Text of the side button
   */
  sideButton?: string;

  /**
   * BydGenericDialogData constructor.
   *
   * @param data BydGenericDialogDataInterface
   */
  constructor(data: BydGenericDialogDataInterface = null) {
    this.title = data?.title || '';
    this.message = data?.message || '';
    this.acceptButton = data?.acceptButton || 'accept';
    this.cancelButton = data?.cancelButton || 'cancel';
    this.state = data?.state || 'primary';
    this.disableClose = data?.disableClose || false;
    this.value = data?.value || '';
    this.valuePlaceholder = data?.valuePlaceholder || '';
    this.disableTips = data?.disableTips || '';
    this.deleteButton = data?.deleteButton || '';
    this.sideButton = data?.sideButton || '';
    this.existingValues = data?.existingValues || [];
  }
}
